import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import ChargeTransactionDetailScreen from './screens/ChargeTransactionDetailScreen';
import ChargeTransactionListScreen from './screens/ChargeTransactionListScreen';

function ChargeTransaction(props) {
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<ChargeTransactionListScreen />} />
          <Route path=":chargeTransactionId" element={<ChargeTransactionDetailScreen />} />
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default ChargeTransaction;
